// extracted by mini-css-extract-plugin
module.exports = {"criteria":"DefinitionDisplay-module__criteria___7vTVX"};